import DivisionPage from "@/components/DivisionPage";
import SystemsStatusStrip from "@/components/SystemsStatusStrip";
import { DIVISIONS } from "@/data/content";

const Technology = () => <DivisionPage division={DIVISIONS.tech} afterHero={<SystemsStatusStrip />} />;

export default Technology;
